import styled from 'styled-components';
import color from '../../../../config/colors.json';

export const Title = styled.span`
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-size: 31px;
    color: ${color.sofDark};
    font-weight: 500;
    margin-bottom: 31px;
`;

export const Subtitle = styled.span`
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-size: 22px;
    line-height: 33px;
    color: ${color.lightGrey21};
    font-weight: 300;
    margin-bottom: 31px;
`;
